import { QueryClient, useQuery } from '@tanstack/react-query';

import { GHADiscountSummaryFilters, getGHADiscountSummary } from '~/services/ConnectionGoogleService';

export const ghaDiscountSummaryQueryKeys = {
  all: ['ghaDiscountSummary'] as const,
  summary: (filters: GHADiscountSummaryFilters) => [...ghaDiscountSummaryQueryKeys.all, filters] as const,
};

/** Scoped-rule and exclusion mutations change this rollup; without an explicit invalidation the
 *  5-minute staleTime would show the pre-change world until it expires. */
export function invalidateGHADiscountSummary(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: ghaDiscountSummaryQueryKeys.all });
}

export function useGHADiscountSummary(filters: GHADiscountSummaryFilters = {}) {
  return useQuery({
    queryKey: ghaDiscountSummaryQueryKeys.summary(filters),
    queryFn: async ({ signal }) => {
      const response = await getGHADiscountSummary(filters, { signal });
      return response.result;
    },
    // The rollup is several full property-table scans server-side; keep it fresh for 5 minutes
    // so switching sub-tabs doesn't re-pay that cost. The Refresh button refetches regardless.
    staleTime: 5 * 60 * 1000,
  });
}
